<template>
    <!-- eslint-disable-next-line vue/no-mutating-props -->
    <Collapse v-model:activeKey="dataTable.options.search.activeKey">
        <CollapsePanel :header="$t('components.table.search.title')" key="Search">
            <Form layout="horizontal" :labelCol="{ xs: 24, md: 9 }" :wrapperCol="{ xs: 24, md: 15 }">
                <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields"></TemplateBuilder>
            </Form>
            <div class="text-center mt-2">
                <Button @click="() => onClickReset({ props, data, emit })" size="small">
                    <CIcon file="reset.svg"></CIcon>
                    <span>{{ $t("button.reset") }}</span>
                </Button>
                <Button @click="() => onClickSearch({ props, data, emit })" class="ml-2 btn-primary" size="small">
                    <CIcon file="search.svg"></CIcon>
                    <span>{{ $t("button.search") }}</span>
                </Button>
            </div>
        </CollapsePanel>
    </Collapse>
</template>

<script>
import { defineComponent, defineAsyncComponent, reactive, watch } from "vue";
import { Form, Collapse, Button } from "ant-design-vue";
import { init, onClickSearch, onClickReset } from "./search-panel.logic";

export default defineComponent({
    components: {
        Form,
        Collapse,
        CollapsePanel: Collapse.Panel,
        Button,
        TemplateBuilder: defineAsyncComponent(() => import("../input/template-builder/TemplateBuilder")),
        CIcon: defineAsyncComponent(() => import("../icon/CIcon"))
    },
    props: {
        propsTable: {},
        dataTable: {},
        columns: {}
    },
    emits: ["search"],
    setup(props, { emit }) {
        const data = reactive({ rowProp: { gutter: 24 } });
        init({ props, data, emit });
        watch(
            () => props.columns,
            () => init({ props, data, emit }),
            { flush: "post" }
        );
        return { props, data, emit, onClickSearch, onClickReset };
    }
});
</script>
